import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-xxl-7" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FKBreadCrumb = _resolveComponent("FKBreadCrumb")!
  const _component_UserAnagraph = _resolveComponent("UserAnagraph")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FKBreadCrumb, { page: _ctx.user_fullname }, {
      default: _withCtx(() => [
        _createCommentVNode(" <FKBreadCrumbItem :page=\"$t('page.system_users')\" to=\"/system-users\" /> ")
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["page"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_UserAnagraph)
      ]),
      _hoisted_3
    ])
  ], 64 /* STABLE_FRAGMENT */))
}